import { Container, Content, Headline } from '@volumental/common';
import { sendEvent } from '@volumental/link';
import { type JSX } from 'react';
import { useTranslation } from 'react-i18next';
import { Header } from '../components/accessible-components';

export function FlowNotSupported(): JSX.Element {
  const { t } = useTranslation();
  const close = (): void => {
    sendEvent({
      type: 'close',
      data: undefined,
    });
  };
  return (
    <Container>
      <Header close={close} />
      <Content>
        <Headline>{t('flowNotAvailable')}</Headline>
      </Content>
    </Container>
  );
}
